import { trackClientError, TrackClientErrorFunc } from "./error-factory";

// Important notes for this file:
// - Use snake case: signup_button_click instead of signupButtonClick
// - Only use lowercase letters
// - Use present-tense verbs: "submit" instead of "submitted"
// - Keep events in alphabetical order
// - For event names, follow the `category:object_action` framework: For example, account_settings:password_updated or signup_flow:create_account

export const trackClientErrorBoundary: TrackClientErrorFunc<{
  error_title: string;
  message: string;
  digest: string | null;
  replay_url: string | null;
}> = (p) => trackClientError(p);

export const trackClientErrorLoadDealMemoDialog: TrackClientErrorFunc<{
  deal_memo_id: string;
}> = (p) => trackClientError(p);

export const trackClientErrorOccurred: TrackClientErrorFunc<{
  context?: string;
}> = (p) => trackClientError(p);

export const trackClientErrorSendCreatorMenuFailure: TrackClientErrorFunc<{
  invite_slug: string;
  creator_id: string;
  error_message: string;
}> = (p) => trackClientError(p);

export const trackClientErrorSendMenuLinkFailed: TrackClientErrorFunc<{
  current_url: string;
  invite_slug: string;
  error_message: string;
}> = (p) => trackClientError(p);
